/* RVA: on mobile, move the product title + price blocks above the media.
   Instead of duplicating the blocks (which would clash on the data-dynamic-variant-content
   ids the variant picker updates), this moves the actual nodes into a container rendered
   above the media on mobile, and moves them back to their original position on desktop.
   Comment anchors mark each node's home so the original order is restored exactly. */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function setup(root) {
    var top = root.querySelector('[data-rva-mobile-details-top]');
    if (!top) return;

    var items = [];
    ['.title-row', '.price-container'].forEach(function (sel) {
      var el = root.querySelector(sel);
      if (el) items.push(el);
    });
    if (!items.length) return;

    // Leave a comment anchor at each node's original position (once).
    items.forEach(function (el) {
      if (!el.rvaAnchor) {
        var anchor = document.createComment('rva-details-anchor');
        el.parentNode.insertBefore(anchor, el);
        el.rvaAnchor = anchor;
      }
    });

    function apply() {
      if (mq.matches) {
        // Mobile: move into the top container, in order.
        items.forEach(function (el) { top.appendChild(el); });
      } else {
        // Desktop: restore each node right after its anchor.
        items.forEach(function (el) {
          el.rvaAnchor.parentNode.insertBefore(el, el.rvaAnchor.nextSibling);
        });
      }
    }

    apply();
    if (mq.addEventListener) {
      mq.addEventListener('change', apply);
    } else if (mq.addListener) {
      mq.addListener(apply);
    }
  }

  function init() {
    document.querySelectorAll('.rva-mobile-details-above').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
